import { render, staticRenderFns } from "./PhoneVerificationFlow.vue?vue&type=template&id=58f2e86f"
import script from "./PhoneVerificationFlow.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports